import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { environment } from 'src/environments/environment'


@Injectable()
export class UsuarioService {

    cadastrarFuncionarioURL: string = environment.urlBackend + environment.cadastrarUsuario
    updateFuncionarioURL : string = environment.urlBackend + environment.atualizarUsuario
    updateConfiguracaoURL : string = environment.urlBackend + environment.atualizarConfiguracao
    clientID: string = environment.clientId
    clientSecret: string = environment.clientSecret
    errors: String[]


    constructor(
        private router: Router,
        private http: HttpClient
    ){ }









}
